<template>
  <div class="h-full">
    <h3 class="text-xl font-bold text-dark mb-4">{{ title }}</h3>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
}
defineProps<Props>();
</script>

<style scoped></style>
